<template>
  <div class="d-flex mb-3 mt-2">
    <!-- <b-dropdown
    size="sm"
    right
    variant="default"
    toggle-class="text-decoration-none"
    no-caret
    ref="dropdown"
  >
    <template slot="button-content"
      ><i class="fa fa-cogs"></i
    ></template> -->
    <!-- <b-dropdown-form class="pl-3 pr-3"> -->
    <b-form-checkbox
      @input="toggleConfirmation('booking_confirmation')"
      :checked="!!user.supplier.booking_confirmation"
      switch
      class="mr-4"
    >
      Send e-post ved nye bookinger
      <i
        v-b-tooltip.hover
        title="Motta en e-postbekreftelse hver gang en deltaker booker seg på en ledig dato."
        class="fa fa-info-circle hoverable"
      ></i>
    </b-form-checkbox>
    <b-form-checkbox
      @input="toggleConfirmation('booking_sum_confirmation')"
      :checked="!!user.supplier.booking_sum_confirmation"
      switch
    >
      Send e-post når booking stenger
      <i
        v-b-tooltip.hover
        title="Motta en e-post ved bookingfrist som oppsummerer antall påmeldte deltakere, samt link til å laste ned deltakerlister."
        class="fa fa-info-circle hoverable"
      ></i>
    </b-form-checkbox>
    <!-- </b-dropdown-form>
  </b-dropdown> -->
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    ...mapActions({
      getAvailableDates: 'bookings/getAvailableDates',
      getUser: 'auth/getUser',
    }),
    toggleConfirmation(type) {
      const url = `${this.rootUrl}/me/notifications`;

      axios.put(url, { type: type }).then(res => {
        this.getUser();
        this.$bvToast.toast(`E-post instillingerne er nå endret`, {
          variant: 'success',
          title: 'Instillinger oppdatert',
          autoHideDelay: 5000,
        });
      });
    },
    submitForm() {
      let origParticipants = this.event.participants;
      const url = `${this.rootUrl}/bookings/dates/${this.event.id}/participants`;
      axios.put(url, { participants: this.participants }).then(res => {
        this.$refs.dropdown.hide(true);
        this.getAvailableDates();
        this.$bvToast.toast(
          `Antallet plasser er nå endret fra ${origParticipants} til ${this.participants}`,
          {
            variant: 'success',
            title: 'Antallet plasser er nå endret',
            autoHideDelay: 5000,
          }
        );
      });
    },
  },
};
</script>